import React from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import { FiRepeat } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import { useDispatch } from 'react-redux'
import {
  Label,
  Link,
  MenuElement,
} from '../../../../../components/Template/Sidebar'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import reloadApplication from '../../../../../actions/synchronize/reloadApplication'
import { Mixpanel } from '../../../../../utils/Mixpanel'

function Refresh({ size = 1 }: IWithSize & WithTranslation) {
  const dispatch = useDispatch()

  function reload() {
    dispatch(reloadApplication())
    Mixpanel.track('Menu Refresh Clicked', [])
  }

  return (
    <MenuElement size={size} alignCenter={true}>
      <Link size={size} onClick={reload} to={'#refresh'}>
        <Flex alignCenter={true}>
          <b>
            <FiRepeat size={16 * size} />
          </b>
          <Label size={size} primary={true}>
            <Trans i18nKey={'BB0_refresh_database'}>Odśwież aplikację</Trans>
          </Label>
        </Flex>
      </Link>
    </MenuElement>
  )
}

export default Refresh
